import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { hasAveragePriceAdjustments } from "../../../utils/listings";
import { getTag } from "../../../utils/listing";
import Image from "../../common/Image";
import {
  ComparableImage,
  ComparableAddress,
  ComparableDetails,
  ComparableDifferencesDynamic
} from "../../comparable";
import { useLive } from "../LiveProvider";
import {
  Header,
  ImageContainer,
  Tag,
  Comparable,
  Overflow,
  GlobalStyle
} from "./styled/live-listing";

function LiveListing({ listing, onClick, ...props }) {
  const {
    visibleListings,
    subjectProperty,
    isAcreageReport,
    comparisonFields
  } = useLive();
  const hasPriceAdjustments = hasAveragePriceAdjustments(visibleListings);
  const tag = getTag(listing, visibleListings, subjectProperty);
  const [comparisonFieldsWithValues, setComparisonFieldsWithValues] = useState(
    []
  );

  useEffect(() => {
    setComparisonFieldsWithValues(
      comparisonFields.map((obj) => {
        if (subjectProperty[obj.lookupName] !== undefined) {
          obj.value = subjectProperty[obj.lookupName];
        }
        return obj;
      })
    );
  }, [subjectProperty, comparisonFields]);

  return (
    <>
      <GlobalStyle />
      <Comparable {...props} onClick={onClick}>
        <ImageContainer>
          {!!tag && <Tag>{tag}</Tag>}
          <ComparableImage>
            <Image
              src={listing.photos[0]}
              data-error="Image Unavailable"
              alt="Image Unavailable"
              onClick={onClick}
            />
          </ComparableImage>
        </ImageContainer>
        <ComparableAddress
          street={listing.street}
          cityStateZip={listing.cityStateZip}
          price={listing.price}
          adjustedPrice={listing.adjustedPrice}
          status={listing.status}
          statusColor={listing.statusColor}
        />
        <Overflow>
          <ComparableDifferencesDynamic
            subProp={comparisonFieldsWithValues}
            listingProp={listing}
          />
          <Header
            title="Listing Details"
            className="font-primary comparable-group-header">
            Listing Details
          </Header>
          <ComparableDetails
            originalListPrice={listing.originalListPrice}
            listPrice={listing.listPrice}
            soldPrice={listing.soldPrice}
            price={listing.price}
            adjustedPrice={listing.adjustedPrice}
            soldToListPricePercentage={listing.soldToListPricePercentage}
            showAdjustments={hasPriceAdjustments}
            soldDate={listing.soldDate}
            pricePerSqft={listing.pricePerSqft}
            adjustedPricePerSqft={listing.adjustedPricePerSqft}
            pricePerAcre={listing.pricePerAcre}
            adjustedPricePerAcre={listing.adjustedPricePerAcre}
            dom={listing.dom}
            hasAcres={isAcreageReport}
            virtualTour={listing.virtualTour}
          />
        </Overflow>
      </Comparable>
    </>
  );
}

LiveListing.defaultProps = {
  onClick: () => {}
};

LiveListing.propTypes = {
  listing: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default LiveListing;
